module.exports = __webpack_public_path__ + "media/images/home/boxes/call_and_chat-2e489a8de17f5a81dc5afbaf49952a12.svg";